<template>
  <byted-modal
    v-model="show"
    size="600px"
    class="user-migrate-modal"
    :mask-closable="false"
    :maskable="true"
  >
    <template slot="header">
      <div class="migrate-modal-header" style="line-height: 22px;">
        <strong>尊敬的广告主，您好！</strong>
        <byted-icon name="close" width="20px" height="20px" color="#999" @click="closeMigrateModal"></byted-icon>
      </div>
    </template>
    <template slot="body">
      <span class="migrate-modal-content" style="line-height: 22px;">
        因巨量引擎广告投放平台服务调整，不再支持自助广告投放，当前账号自<strong>2021年12月23日起</strong>无法在本平台继续操作投放。
        为避免资金损失，请尽快通过如下方式申请余额退还：登录账户后，依次进入<strong>【财务】-【资金钱包】-【退款】</strong> 页面申请退款。
        <br/><br/>
        您可通过新平台<strong>【DOU+网页版】</strong> 进行抖音内容加热和营销推广。
      </span>
    </template>
    <template slot="footer">
      <a target="_blank" href="https://doujia.douyin.com/login?dou_plus_compaign_name=%E5%BD%92%E5%9B%A0%E5%8F%82%E6%95%B0%E7%94%A8%E5%81%87%E6%B4%BB%E5%8A%A8+id%3A+2488&dou_plus_content=%7B%22version%22%3A%22v2%22%7D&dou_plus_medium=AD-popup&dou_plus_medium_id=2488&dou_plus_source=campaign&dou_plus_sub_source=oe-website">
        <byted-button class="migrate-modal-btn" style="border: none; background: #F0F0F0;">
          前往DOU+网页版
        </byted-button>
      </a>
      <byted-button type="primary" @click="closeMigrateModal()">我知道了</byted-button>
    </template>
  </byted-modal>
</template>

<script>
  export default {
    name: "user-migrate-modal",
    props: {
      show: false,
      disableKey: ""
    },
    data() {
      return {
        test: true,
        migrateModalVis: false
      }
    },
    created() {
      // 只展示一次。 只要是展示过永久禁用
      if (this.show) {
        localStorage.setItem(this.disableKey, 'true')
      }
    },
    methods: {
      closeMigrateModal() {
        this.$emit('closeMigrateModal')
      },
    }
  }
</script>

<style @scoped lang="scss">

.migrate-modal-content {
  color: #666666;
  font-weight: 400;

  strong {
    color: #333333;
    font-weight: 600;
  }
}

.migrate-modal-header {
  display: flex;
  justify-content: space-between;
}

.migrate-modal-btn a, .migrate-modal-content a {
  color: #338AFF;
  text-decoration: none;
}
</style>
